// utils/preloadIcons.js
let preloaded = false;

export const preloadCategoryIcons = (iconUrls = []) => {
  if (typeof window === "undefined" || preloaded) return;
  preloaded = true;

  iconUrls.forEach((url) => {
    const img = new Image();
    img.src = url;
  });
};
